import React, { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import { Card, CardBody, FormGroup, Label, Input, Button, Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getFormValues, change } from 'redux-form';
import * as submissionFormActions from 'actions/submissionFormActions';
import * as currentUserActions from 'actions/currentUserActions';
import * as finalWizardActions from 'actions/finalWizardActions';
import actionTypes from 'constants/currentUserConstants';

class PasswordForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    currentUser: ImmutablePropTypes.map.isRequired,
    submitForm: PropTypes.func.isRequired,
    goToFinalStep: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool.isRequired,
  };

  state = {
    password: '',
  };

  onPasswordChange = (e) => {
    this.setState({ password: e.target.value });
    this.props.dispatch({ type: actionTypes.AUTHENTICATION_ERROR_RESET });
  };

  forgotPassword = () => this.props.goToFinalStep("reset");
  onCancel = () => this.props.goToFinalStep("email");

  submitForm = (event) => {
    event.preventDefault();
    const { formValues, snapSell } = this.props;

    const afterSignIn = snapSell ?
      () => this.props.fetchBasicUserData() :
      () => this.props.submitForm('preview', this.props.history);

    this.props.signInUser(formValues.email, this.state.password, afterSignIn);
  };

  render() {
    const { formValues, currentUser, formIsLoading } = this.props;
    const isLoading = formIsLoading || currentUser.get('isLoading');
    const confirmationSent = currentUser.get('resent');
    const passwordResetSent = currentUser.get('isPasswordResetSent');
    const error = currentUser.get('error');

    return (
      <Card>
        <div className="card-header">
          <h4>Welcome back!</h4>
        </div>
        <CardBody>
          {confirmationSent && <Alert color="info">
            Please check your email inbox for details on how to confirm your account and set a password.
          </Alert>}
          {passwordResetSent && <Alert color="info">
            Please check your email inbox for details on how to reset your password.
          </Alert>}
          <p>
            We've found an account for <strong>{formValues.email}</strong>.
          </p>
          <p>
            Enter your password to sign in.
          </p>
          <form onSubmit={this.submitForm}>
            <FormGroup>
              <Label>Password *</Label>
              <Input
                type="password"
                value={this.state.password}
                onChange={this.onPasswordChange}
              />
              {error && <p className="text-danger">That's not the right password</p>}
            </FormGroup>
            <Button onClick={this.submitForm} disabled={isLoading || !this.state.password || error} block color="primary">
              {isLoading ? 'Please wait...' : 'Sign in'}
            </Button>
          </form>
        </CardBody>
        <div className="row">
          <div className="col-6">
            <Button onClick={this.forgotPassword} color="link">Forgot your password?</Button>
          </div>
          <div className="col-6 text-right">
            <Button onClick={this.onCancel} color="link">Cancel</Button>
          </div>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  formIsLoading: state.submissionForm.get('isLoading'),
  formValues: getFormValues('eventSubmission')(state),
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
  ...bindActionCreators(currentUserActions, dispatch),
  ...bindActionCreators(finalWizardActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/final/PasswordForm.jsx